import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "@/app/utils/handleApiError";
import { fetchMenus } from "./menus.service";
import { RejectValueType } from "../redux/redux.types";
import { MenusResponse } from "./menus.types";
import { RootState } from "../../store";

export const getMenus = createAsyncThunk<
  MenusResponse,
  void,
  RejectValueType & { state: RootState }
>(
  "menus/getMenus",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchMenus();
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { menus } = getState();
      // ISR veya önceki fetch'ten veri varsa tekrar fetch etme
      if (menus.data) return false;
      if (menus.status === "loading") return false;
      return true;
    },
  },
);